import { Tabs, TabsProps, useTheme } from "@mui/material";
import { hexToRgba } from "@shared/utilities/hexToRgba";

interface IHeaderTabBar extends TabsProps {}

const HeaderTabBar = ({ children, value, ...props }: IHeaderTabBar) => {
  const theme = useTheme();

  return (
    <Tabs
      value={value ?? false}
      aria-label="basic tabs example"
      variant="fullWidth"
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        translate: "-50% -50%",
        width: "fit-content",
        padding: theme.spacing(1),
        minHeight: theme.spacing(1),
        backdropFilter: "blur(12px)",
        background: hexToRgba(theme.palette.dsSurface.v200, theme.palette.dsOpacity.high),
        borderRadius: theme.spacing(3),
      }}
      TabIndicatorProps={{
        sx: {
          backgroundColor: theme.palette.common.white,
          height: "100%",
          zIndex: 0,
          borderRadius: theme.spacing(3),
        },
      }}
      {...props}
    >
      {children}
    </Tabs>
  );
};

export default HeaderTabBar;
